export const getImages = type => {
	switch (type) {
		case "REJECTED":
			return "verifyDeviceError";
		case "NEW_APPROVED":
			return "verifyDeviceSuccess";
		case "LOCKED":
			return "verifyDeviceLock";
		default:
			return "verifyDevice";
	}
};

export const getTitle = type => {
	switch (type) {
		case "REJECTED":
			return "Yêu cầu đăng nhập tài khoản vào thiết bị khác của bạn đã bị từ chối";
		case "NEW_APPROVED":
			return "Yêu cầu đăng nhập đã được duyệt";
		case "LOCKED":
			return "Thiết bị của bạn đã bị khóa đăng nhập";
		default:
			return "Yêu cầu đăng nhập vào thiết bị khác	của bạn đang được kiểm tra";
	}
};

export const getSubTitle = type => {
	switch (type) {
		case "REJECTED":
			return "Lý do: Thiết bị đăng nhập không hợp lệ Vui lòng đóng ứng dụng";
		case "NEW_APPROVED":
			return "Bạn có thể trải nghiệm ứng dụng";
		case "LOCKED":
			return "Vui lòng liên hệ bộ phận DMS để được biết thêm thông tin";
		default:
			return "Bạn vui lòng chờ thêm ít phút nhé!";
	}
};

export const getTitleFooter = type => {
	switch (type) {
		case "REJECTED":
			return "Đóng";
		case "NEW_APPROVED":
			return "Tiếp tục";
		case "LOCKED":
			return "Đóng";
		default:
			return "Chia sẻ";
	}
};
